import script from "./BrowserTypeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrowserTypeList.vue?vue&type=script&setup=true&lang=ts"

import "./BrowserTypeList.vue?vue&type=style&index=0&id=29dc0c7b&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29dc0c7b"]])

export default __exports__